import { useMemo } from "react";
import type { Paywall } from "@/react/types";
import { usePaywallsApi } from "@circle-react/hooks/paywalls/usePaywallsApi";

export const usePaywallsNameMap = () => {
  const { allPaywalls } = usePaywallsApi();

  return useMemo(
    () =>
      allPaywalls.reduce(
        (accumulator: Record<string, string>, record: Paywall) => {
          accumulator[record.id] = record.display_name;
          return accumulator;
        },
        {},
      ),
    [allPaywalls],
  );
};
